import { useQuery } from '@tanstack/react-query';
import { Translator } from 'Translator';
import req from 'utils/req';

const languageCode = Translator.getLanguageCode();
const MAX_COMMENT_LENGTH = 9999;

export function getReviewsForExperiences({ shortIds, maxCommentLength }) {
  return req(
    `${URL_API_HOST}/api/v1/review/by-experience-short-ids?ids=${shortIds.join(
      ',',
    )}&lang=${languageCode}&max_comment_length=${maxCommentLength}`,
  ).get();
}

interface Props {
  shortIds: string[];
  maxCommentLength?: number;
}

function useExperienceListReviews({
  shortIds,
  maxCommentLength = MAX_COMMENT_LENGTH,
}: Props) {
  const res = useQuery(
    ['reviews-by-experiences', shortIds.join(',')],
    async () => getReviewsForExperiences({ shortIds, maxCommentLength }),
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
    },
  );

  return {
    reviews: res.data,
    isLoading: res.isLoading,
  };
}

export default useExperienceListReviews;
